import { AutoMap } from "@automapper/classes";
import { PlageHoraireDTO } from "./plage-horaire.dto";
import { PompeDTO } from "./pompe.dto";


export class CassetteDTO {
    @AutoMap()
    reference!: string;
    @AutoMap()
    typeTetePrelevement!: number;
    @AutoMap()
    refTetePrelevement!: string;
    @AutoMap()
    integrite!: number;
    @AutoMap()
    dureePrelevement!: string;
    @AutoMap(() => [PlageHoraireDTO])
    plageHoraireList: PlageHoraireDTO[] = [];
    @AutoMap()
    pompe!: PompeDTO;

}